import { render, staticRenderFns } from "./BPCard.vue?vue&type=template&id=62f91235&scoped=true&"
import script from "./BPCard.vue?vue&type=script&lang=js&"
export * from "./BPCard.vue?vue&type=script&lang=js&"
import style0 from "./BPCard.vue?vue&type=style&index=0&id=62f91235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f91235",
  null
  
)

export default component.exports